"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DigitInput = _interopRequireDefault(require("./DigitInput"));

var MAX_LENGTH = 6;

var CodeDigit = function CodeDigit(_ref) {
  var isPassword = _ref.isPassword,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      isFocus = _ref.isFocus,
      index = _ref.index,
      value = _ref.value,
      source = _ref.source,
      children = _ref.children;
  var showPlaceholder = value.length === 0 && (!isFocus || disabled);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative flex items-center bg-secondary mx-2 first:ml-0 last:mr-0 w-16 h-12 font-bold', isPassword ? 'text-3xl' : 'text-lg')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center w-full h-6"
  }, children), showPlaceholder && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute left-0 top-0 w-full h-full flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: " bg-gray-light h-1 w-full mx-4",
    style: {
      transform: 'scale(0.6)'
    }
  })));
};

var View = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var value = _ref2.value,
      className = _ref2.className,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'text' : _ref2$type,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["value", "className", "type"]);
  return /*#__PURE__*/_react["default"].createElement(_DigitInput["default"], (0, _extends2["default"])({}, props, {
    autoFocus: true,
    transparent: true,
    ref: ref,
    size: "lg",
    separator: "",
    type: type,
    value: value,
    Digit: CodeDigit,
    length: MAX_LENGTH,
    className: (0, _classnames["default"])('-ml-5', className)
  }));
});
View.displayName = 'CodeDigit';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=CodeInput.js.map